<script setup>
defineProps(['data', 'dataupdate'])
defineEmits(['update:dataupdate'])
</script>

<template>
  <input
    type="text"
    :value="data"
    @input="(event) => $emit('update:dataupdate', event.target.value)"
    class="form-control"
  />
</template>